import { createVNode as l, mergeProps as m } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/FemaleOutlined.js";
import i from "../components/PfIcon.js";
const e = (t, r) => {
  const o = {
    ...t,
    ...r.attrs
  };
  return l(i, m(o, {
    icon: a
  }), null);
};
e.displayName = "FemaleOutlined";
e.inheritAttrs = !1;
export {
  e as default
};
